import React from 'react';

import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface Warning {
  tableColumn?: {
    tableName?: string;
    name?: string;
  };
  reportNames?: string[];
}

interface WarningListProps {
  warnings: Warning[];
}

const WarningList: React.FC<WarningListProps> = ({ warnings }) => {
  const { t } = useTranslation();
  if (!warnings.length) {
    return null;
  }

  return (
    <>
      <p className="text-bodyLg text-neutral-900 dark:text-neutral-100 dark:text-neutral:100 text-left mb-5">
        {t('WarningSomeReportsMightHaveProblems')}:
      </p>
      <ol className="list-decimal ml-6 text-neutral-900 dark:text-neutral-100 text-left">
        {warnings.map((warning) => (
          <li key={warning.tableColumn?.name} className="mb-2">
            <div className="flex items-center">
              <p className="text-bodyLg">{warning.tableColumn?.tableName}</p>
              <FontAwesomeIcon icon={faArrowRight} className="mx-1" />
              <p className="text-bodyLg">{warning.tableColumn?.name}</p>
            </div>
            <ul className="text-bodyLg list-disc ml-6">
              {warning.reportNames?.map((reportName: string) => <li key={reportName}>{reportName}</li>)}
            </ul>
          </li>
        ))}
      </ol>
      <p className="text-bodyLg text-neutral-900 dark:text-neutral-100 dark:text-neutral:100 text-left mt-5">
        {t('ConfirmSomeReportsMightHaveProblems')}
      </p>
    </>
  );
};

export default WarningList;
